import { GarageProperties } from "@App/types/enums";
import { hasItems } from "@App/utils/array";
import { OrganizationIsMeinAuto } from "@App/utils/conditionals/organization";
import { ServiceIsVehicleReturn } from "@App/utils/conditionals/services";
import type { GarageProperty } from "@App/apis/graphql/perimeterSearch/responses/garageProperty";
import type { AvailableFilterItem } from "@App/contexts/listing/GaragePropertyContext";
import type { ID, Organization, Service } from "@App/types";

interface useFreeVehicleReturnProps {
  availableGarageProperties: GarageProperty[];
  selectedGarageProperties: ID[];
  availableFilterItems: AvailableFilterItem[];
  setGarageProperties: (ids: ID[]) => void;
  organization: Organization | null;
  service: Service | null;
}

export const useFreeVehicleReturn = ({
  availableGarageProperties,
  selectedGarageProperties,
  availableFilterItems,
  setGarageProperties,
  service,
  organization,
}: useFreeVehicleReturnProps) => {
  const freeVehicleReturnProperty = availableGarageProperties?.find(
    (g) => g.internal_identifier === GarageProperties.FREE_VEHICLE_RETURN,
  );
  const isFreeVehicleReturnFilterToggled = selectedGarageProperties?.includes(
    freeVehicleReturnProperty?.id,
  );
  const showFreeVehicleReturnHint =
    hasItems(availableFilterItems) &&
    OrganizationIsMeinAuto(organization) &&
    ServiceIsVehicleReturn(service);
  const removeFreeVehicleReturnFromFilters = () => {
    setGarageProperties([]);
  };
  const toggleFreeVehicleReturnFilter = () => {
    const newGarageProperties = freeVehicleReturnProperty?.id ? [freeVehicleReturnProperty.id] : [];
    setGarageProperties(newGarageProperties);
  };
  const vehicleReturnHintOnClick = isFreeVehicleReturnFilterToggled
    ? removeFreeVehicleReturnFromFilters
    : toggleFreeVehicleReturnFilter;

  return {
    isFreeVehicleReturnFilterToggled,
    showFreeVehicleReturnHint,
    vehicleReturnHintOnClick,
  };
};
